<template>
    <div
    class="the-map-sound-button absolute flex items-center faa-fade faa-opti"
    :class="{ 'faa-fade-in': ready }">
        <audio
        class="hidden"
        ref="audio"
        src="@/assets/sounds/map_bg.mp3"
        autoplay
        loop
        @playing="updatePlayingState"
        ></audio>
        <div
        class="the-map-sound-button-container bg-blue rounded-full p-3 cursor-pointer"
        @click="toggleSound">
            <img v-if="muted" src="@/assets/images/sound-off-icon.svg" @load="loaded">
            <img v-else src="@/assets/images/sound-on-icon.svg" @load="loaded">
        </div>
        <p v-if="muted" class="text-white bg-blue-dark rounded px-4 py-2 ml-4">
            Activer le son
        </p>
        <p v-else class="text-white bg-blue-dark rounded px-4 py-2 ml-4">
            Couper le son
        </p>
    </div>
</template>

<script>
    import keyboardShortcutMixin from '@/mixins/keyboardShortcutMixin'
    
    export default {
        name: 'TheMapSound',
        mixins: [keyboardShortcutMixin],
        data() {
            return {
                wasMuted: 0,
                muted: true,
                ready: false,
                // Keyboard shortcuts
                keyboardShortcuts: {
                    m: this.toggleSound,
                    77: this.toggleSound,
                },
            }
        },
        mounted() {
            this.wasMuted = localStorage.getItem('muted-map-sound')
            
            if (parseInt(this.wasMuted, 10) == 1 && this.$refs.audio) {
                this.$refs.audio.pause()
                this.updatePlayingState()
            }
        },
        beforeDestroy() {
            // Stop sound (some browser keep playing even if the HTML node is removed)
            if (this.$refs.audio) {
                this.$refs.audio.pause()
            }
        },
        watch: {
            muted(muted) {
                localStorage.setItem('muted-map-sound', (muted ? 1 : 0))
            },
        },
        methods: {
            loaded() {
                this.ready = true
            },
            toggleSound() {
                if (!this.$refs.audio) {
                    this.muted = true
                    return
                }

                if (this.$refs.audio.paused) {
                    this.$refs.audio.play()
                } else {
                    this.$refs.audio.pause()
                }

                this.updatePlayingState()
            },
            updatePlayingState() {
                if (!this.$refs.audio) {
                    this.muted = true
                    return
                }

                this.muted = this.$refs.audio.paused
            },
        }
    }
</script>

<style lang="scss" scoped>

.the-map-sound-button {
    @apply mt-6;
    top: 0;
    left: 20px;

    p {
        opacity: 0;
        transition: opacity .5s;
    }

    &-container {
        width: 60px;
        height: 60px;

        img {
            max-width: 100%;
            max-height: 100%;
        }

        &:hover {
            & + p {
                opacity: 1;
            }
        }
    }
}

</style>
